import Vue from 'vue';
import ButtonObject from '@/components/global/button-object';
import LimitInput from '@/components/global/limit-input';
import InputRadio from '@/components/global/input-radio';
import SvgIcon from '@/components/global/svg-icon';

Vue.component('ButtonObject', ButtonObject);
Vue.component('LimitInput', LimitInput);
Vue.component('InputRadio', InputRadio);
Vue.component('SvgIcon', SvgIcon);
